import React, { Component } from 'react'
import { Flex } from 'hljd'

export default class extends Component {
  render() {
    const { title, value, extra, ...rest } = this.props

    return (
      <Flex d="v" {...rest}>
        <span style={{ color: '#666', marginBottom: 6 }}>{title}</span>
        <span
          style={{
            color: '#333',
            fontSize: 28,
            fontWeight: 'bold',
            marginBottom: 4
          }}
        >
          {value}
        </span>
        {extra}
      </Flex>
    )
  }
}
